export default __webpack_public_path__ + "static/media/viber.6ef1e009.svg";